var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14C21.1046 14 22 13.1046 22 12Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75736 4.92856C8.53841 5.70961 8.53841 6.97594 7.75736 7.75699C6.97631 8.53804 5.70998 8.53804 4.92893 7.75699C4.14788 6.97594 4.14788 5.70961 4.92893 4.92856C5.70998 4.14751 6.97631 4.14751 7.75736 4.92856Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 19.0714C19.8521 18.2904 19.8521 17.0241 19.0711 16.243C18.29 15.462 17.0237 15.462 16.2426 16.243C15.4616 17.0241 15.4616 18.2904 16.2426 19.0714C17.0237 19.8525 18.29 19.8525 19.0711 19.0714Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92893 16.2427C5.70998 15.4617 6.97631 15.4617 7.75736 16.2427C8.53841 17.0238 8.53841 18.2901 7.75736 19.0711C6.97631 19.8522 5.70998 19.8522 4.92893 19.0711C4.14788 18.2901 4.14788 17.0238 4.92893 16.2427Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 4.92922C18.29 4.14818 17.0237 4.14818 16.2426 4.92922C15.4616 5.71027 15.4616 6.9766 16.2426 7.75765C17.0237 8.5387 18.29 8.5387 19.0711 7.75765C19.8521 6.9766 19.8521 5.71027 19.0711 4.92922Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner4);
export default __webpack_public_path__ + "static/media/spinner-4.737b245dd77f50b9d428af96519a52fe.svg";
export { ForwardRef as ReactComponent };